<m4s-header></m4s-header>

<div class="content-container">
  <div class="content">
    <div class="outlet-wrapper">
      <router-outlet>
      </router-outlet>
    </div>
  </div>

  <m4s-footer></m4s-footer>
</div>
